import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import ArrowLeftRightRegular from './arrow-left-right-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <ArrowLeftRightRegular {...validProps} />;
}
SvgComponent.iconName = 'arrowLeftRightRegular';

export const ArrowLeftRightRegularIcon = svgIconWrapper(SvgComponent);
